//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            categories: ['Entradas', 'Hamburguesas', 'Bebidas'],
        }
    },
}
